import lodash from "lodash";

const ID_SEPARATOR = "---";

export const constructUrlFromTitleAndId = (title: string, id: string) =>
  `${lodash.kebabCase(title)}${ID_SEPARATOR}${id}`;

export const getIdFromUrl = (url: string) =>
  url.split(ID_SEPARATOR).slice(-1)[0];
